import { createFileRoute } from "@tanstack/react-router";
import AdminContactDetail from "@/pages/AdminContactDetail";

export const Route = createFileRoute("/admin/events/contact/$id/")({
  component: AdminContactDetail,
});
